import { EngineeringManagerType } from 'providence-types';
import { OptionProps } from '../interfaces';

export const ENGINEERING_TYPES_OPTIONS: OptionProps[] = [
  { viewValue: 'All', value: EngineeringManagerType.All },
  { viewValue: 'NSB', value: EngineeringManagerType.NSB },
  { viewValue: 'LTE', value: EngineeringManagerType.LTE },
];
